import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// // // LIST ALL Games
export const gamesList = (params = '') => Http.get(`/showcase-games${serialize(params)}`)

export const gameCreate = (params = '') => Http.post('/showcase-games', params)
export const gameByID = (params = '') => Http.get(`/showcase-games/${params}?include=event,submission,game`)
export const gameUpdate = (params = '') => Http.put(`/showcase-games/${params.id}`, params)
export const gameDestroy = (params = '') => Http.delete(`/showcase-games/${params.id}`)
